import React from 'react';
import { Modal, Row, Col, Image } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

const ImageModal = ({ show, onHide, images }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Images</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {images?.length ? (
          <PhotoProvider>
            <Row>
              {images.map((img, idx) => (
                <Col sm={4} key={img ?? idx} className="mb-3">
                  <PhotoView src={img}>
                    <Image
                      src={img}
                      fluid
                      rounded
                      style={{ cursor: 'pointer' }}
                    />
                  </PhotoView>
                </Col>
              ))}
            </Row>
          </PhotoProvider>
        ) : (
          <div className="text-center">No images available</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

ImageModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  images: PropTypes.array
};

export default ImageModal;